import { Pipe, PipeTransform } from '@angular/core';
import { NameFormatService } from 'app/services/name-format/name-format.service';

@Pipe({
    name: 'nameChart',
    pure: false
})
export class NamePipe implements PipeTransform {

    constructor(private nameFormatService: NameFormatService) {}

    transform(value: string, firstName: string, lastName: string, format: string): any {
        // Use the centralized NameFormatService to respect user preference
        const formattedName = this.nameFormatService.formatName(firstName, lastName);
        
        // Apply uppercase to lastname portion if format indicates it
        // Check if format has %s (surname) before %f (firstname) - this indicates surname-first format
        if (!format || !format.includes('%s') || !format.includes('%f')) {
            return formattedName;
        }
        
        // Apply case transformations based on the format string
        lastName = lastName ? lastName.toUpperCase() : '';
        
        // Return formatted name with uppercase applied to the surname portion
        const parts = formattedName.split(' ');
        if (this.nameFormatService.getCurrentFirstnameFirst()) {
            // firstname first: apply uppercase to last part (surname)
            return parts.slice(0, -1).join(' ') + ' ' + parts[parts.length - 1].toUpperCase();
        } else {
            // surname first: apply uppercase to first part (surname)
            return parts[0].toUpperCase() + ' ' + parts.slice(1).join(' ');
        }
    }

}
